import { jsxs, jsx } from 'react/jsx-runtime';
import { FormLabelRequiredText } from './FormLabelRequiredText.es.js';

const root = "_root_1i2of_1";
const asterisk = "_asterisk_1i2of_45";
const styles = {
	root: root,
	asterisk: asterisk
};

const FormLabel = ({ alignItems = "center", children, htmlFor = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, isSelected = void 0, justifyContent = "start", requiredText = void 0, size = "medium" }) => {
  return jsxs("label", { className: styles.root, "data-align-items": alignItems, "data-justify-content": justifyContent, "data-size": size, "data-state": [
    isSelected && "selected",
    isErrored && "errored",
    isDisabled && "disabled"
  ].filter(Boolean).join(" ") || void 0, "data-zds": true, htmlFor, children: [children, isRequired && jsx("abbr", { className: styles.asterisk, title: "required", children: "*" }), isRequired ? requiredText ? jsx(FormLabelRequiredText, { isDisabled, children: requiredText }) : jsx(FormLabelRequiredText, { isDisabled }) : null] });
};

export { FormLabel };
//# sourceMappingURL=FormLabel.es.js.map
